// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style_wrapper__ceUnq","logo":"style_logo__fBNtP","service":"style_service__WjYcl","serviceTitle":"style_service-title__WhlOU"};